'use client'

import {useRouter} from 'next/navigation';
import {buildURL} from '@/util/url';
import {makeRequest} from '@/util/makeRequest';
import {useIdleTimer} from 'react-idle-timer';
import axios from 'axios';

export function IdleRedirector({returnTo, timeoutDuration}: {returnTo?: string, timeoutDuration?: number}) {
  const router = useRouter();
  useIdleTimer({
    // if no activity for 17 minutes, will call `onIdle`. set up to be 2 minutes longer than the session timeout time to ensure
    // we don't redirect you to login just for your session to get updated and then you to get redirected back
    timeout: timeoutDuration ? timeoutDuration * 1000 : 17 * 60 * 1000,
    onIdle: () => router.push(buildURL('/api/auth/login', {returnTo})),
    // on any action (click, move mouse, etc), throttle every 1 minute, will make get request to this api url
    throttle: 60 * 1000,
    onAction: () => makeRequest({url: '/api/keepalive', method: 'GET'})
      .catch((err) => {
        console.error(err)
        if (axios.isAxiosError(err) && err.status === 401) {
          router.push(buildURL('/api/auth/login', {returnTo}))
        }
      }),
  });

  return null;
}
